<template>
	<div>
		<div v-if='isMenu' id="overlay">
			<div class='close' v-on:click='toggleMenu()'></div>
			<div v-for='nav in navigation' v-bind:key='nav.link'>
				<span v-if='!isHome'>
				<router-link to='/'><li v-bind:class="{}"><div class='underline'></div>Home</li></router-link>
			</span>
				<span v-if='isHome'>
					<router-link @click="scrollMeTo('about')" v-if='nav.link' :to='nav.link'><li v-bind:class="{ active: isMenuActive(nav.link) }"><div class='underline'></div>{{nav.label}}</li>
					</router-link>
				</span>

				<div v-if='nav.link' class='nav-splitter'></div>
			</div>

			<div class='nav-splitter'></div>
			<div>
				<li v-if='isTermine' @click='changeLang'><div class='underline'></div>{{langLabel()}}</li>
			</div>


		</div>
	<div id='navigation'>
		<router-link to="/">
			<div id="logo"></div>
		</router-link>
		<!-- <div id="hamburger" v-bind:class='{active: isMenu}' v-on:click='toggleMenu()'></div> -->

		<button class="hamburger hamburger--slider" type="button" v-bind:class='{"is-active": isMenu}' v-on:click='toggleMenu()'>
		  <span class="hamburger-box">
		    <span class="hamburger-inner"></span>
		  </span>
		</button>

		<ul id='topnav'>
			<span v-if='!isHome'>
				<router-link to='/'><li v-bind:class="{}"><div class='underline'></div>Home</li></router-link>
			</span>
			<span v-if='isHome'>
			<span v-for='nav in navigation'  v-bind:key='nav.link'>
				<router-link @click="scrollMeTo()" v-if='nav.link' :to='nav.link'><li v-bind:class="{ active: isMenuActive(nav.link) }"><div class='underline'></div>{{nav.label}}</li></router-link>
			</span>
			</span>
<!-- 			<router-link v-if='!isCurrentUser' to='/login'><li v-bind:class="{ active: isMenuActive('/login') }"><div class='underline'></div>Login</li></router-link>			 -->
			<!-- <li @click='logout' v-if='isCurrentUser'><div class='underline'></div>Logout</li> -->


			<li v-if='isTermine' @click='changeLang'><div class='underline'></div>{{langLabel()}}</li>
		</ul>
	</div>
	</div>
</template>

<script>
	import Router from 'vue-router';
	export default {
		name: 'navigation',
		props: {
			navigation: Array,
			lang: String,
			langLink: String,
			isCurrentUser: Boolean,
			slogan: String,

		},
		data() {
			return {
		        isMenu: false,
		        isHome: true,
		        isTermine: false
			}
		},
		watch:{
		    $route (to, from){
		        this.isMenu = false;
		        this.isPathHome();
		        this.isPathTermin();
		    }
		},
		methods: {
			isPathHome() {
				// let path = this.$route.path
				// console.log(path)
				let path = window.location.href
				// let isHome = true
				if(window.location.pathname === "/") {
					this.isHome = true
				} else {
					this.isHome = false
				}

				console.log(window.location.pathname === "/");
				// console.log(path.substring(path.indexOf("#"),path.length))

				// let isHome = path.substring(path.indexOf("#"),path.length)

				// return isHome
			},
			isPathTermin() {
				// let path = this.$route.path
				// console.log(path)
				let path = window.location.href
				// let isHome = true
				console.log('TERMINEEEEE');
				if(window.location.pathname === "/termine") {
					console.log(window.location.pathname);
					this.isTermine = false
				} else {
					console.log(window.location.pathname);
					this.isTermine = true
				}

				console.log('path', window.location.pathname);
				console.log(window.location.pathname === "/termine");
				// console.log(path.substring(path.indexOf("#"),path.length))

				// let isHome = path.substring(path.indexOf("#"),path.length)

				// return isHome
			},

			toggleMenu() {
				console.log('toggle');
				if(this.isMenu) {
					this.isMenu = true
				} else {
					this.isMenu = true
				}

			},
			langLabel(){
				if(this.lang === 'de'){

					return 'DE'
				} else {
					return 'EN'
				}
			}
			,
			logout() {
				this.$emit('logout')

			},
			changeLang() {
				this.$emit('langChange')
			},
			isMenuActive(route) {
				var currentRoute = '/'+this.$route.name
				return currentRoute == route ? true : false
			},
			scrollMeTo(refName) {
				// console.log('PATHH::');
				// let path = $route.path
				// console.log(path)


			    // var element = this.$refs[refName];
			    // var top = element.offsetTop;

			    // window.scrollTo(0, top);
			}

		},
		mounted: function (){
			console.log('TERMINME');
			this.isPathTermin();
			this.isPathHome();
		}
	}
</script>

<style lang="less">

@import '../less/variables.less';

	#overlay {
		margin: 0px;
		padding: 0px;
		top: 0px;
		left: 0px;
		position: fixed;
		width: 100%;
		height: 100%;
		z-index: 11;
		background-color: @c2;
		padding-top: 22%;
		text-align: center;
		.nav-splitter {
			position: relative;
			height: 1px;
			width: 70%;
			margin-left: auto;
			margin-right: auto;
			background-color: rgba(255,255,255,0.1);
		}
		a {
			color: white;
			text-decoration: none;
			margin: 0px;
			padding: 0px;
		}
		li {
			margin: 0px;
			padding: 0px;
			.fmb(14px);
			display: inline-block;
			text-transform: uppercase;
			line-height: 50px;
			cursor: pointer;
			position: relative;
			text-align: center;
		 	list-style-type: none;
			&:hover {
				// opacity: 0.7;
				.underline {
					// visibility: visible;

				}
			}
			.underline {
				position: absolute;
				width: 0%;
				height: 2px;
				background-color: @c1;
				// .br(2px);
				bottom: 14px;
				transition: all ease 0.5s;
				// visibility: hidden;
			}
			&.active {
				.underline {
					// visibility: visible;
					width: 100%;
				}
			}

		}
	}
#navigation {
	position: absolute;
	top: 0px;
	left: 0px;
	width: 90%;
	height: 80px;
	padding: 0px 1%;
	// background-color: red;
	margin: 0px;
	margin-top: 70px;
	z-index: 11;
	@media (max-width: @mobile_width) {
		width: 100%;
		height: 10px;
		margin-top: 10px;
		padding: 0px 0px;

	}

	#logo {
		background-image: url('/images/logo.svg');
		background-position: center center;
		background-repeat: no-repeat;
		background-size: auto 100% ;
		width: 300px;
		height: 80px;
		float: left;
		margin-right: 40px;
		@media (max-width: @mobile_width) {
			clear: both;
			float: none;
			width: 130px;
			position: absolute;
			left: 50%;
			margin-left: -65px;

		}

	}
	#slogan {
		margin-top: 2px;
		height: 80px;
		.fm(23px);
		letter-spacing: 1.8px;
		text-transform: uppercase;
		float: left;
		line-height: 80px;
		@media (max-width: @mobile_width) {
			display: none;
		}
	}

	.hamburger {
		visibility: hidden;
		position: absolute;
		right: 20px;
		top: 15px;
		outline: none;

		@media (max-width: 1200px) {
			visibility: visible;

		}

		.hamburger-inner::before {
			background-color: red;
			display: none;
		}

		.hamburger-inner::after {
			margin-top: -13px;
		}

		&.is-active {
			.hamburger-inner::after {
			margin-top: 0px;
			}
		}
	}

	#topnav {
		.fmb(14px);
		letter-spacing: 1.4px;
		list-style-type: none;
		padding: 0px;
		margin:0px;
		float: right;
		height: 80px;
		@media (max-width: 1200px) {
			display: none;

		}

		a {
			margin: 0px;
			padding: 0px;
			color: white;
		}

		li {
			display: inline-block;
			text-transform: uppercase;
			margin-left: 50px;
			line-height: 80px;
			cursor: pointer;
			position: relative;
			&:hover {
				// opacity: 0.7;
				.underline {
					// visibility: visible;
					opacity: 1;


				}
			}
			.underline {
				position: absolute;
				width: 150%;
				height: 43px;
				margin-left: -25%;
				background-color: transparent;
				// .br(2px);
				bottom: 18px;
				transition: all ease 0.3s;
				border: solid;
				border-color: white;
				box-sizing: border-box;
				-moz-box-sizing: border-box;
				-webkit-box-sizing: border-box;
				opacity: 0;
				border-width: 2px;
				// visibility: hidden;
			}
			&.active {
				.underline {
					// visibility: visible;
					opacity: 1;
				}
			}

		}

	}

}

</style>
